export function ageOf(dob: string, ref = new Date()): string {
  const b = new Date(dob + 'T00:00:00');
  if (isNaN(b.getTime())) return '';
  let y = ref.getFullYear() - b.getFullYear();
  const md = ref.getMonth() - b.getMonth();
  if (md < 0 || (md === 0 && ref.getDate() < b.getDate())) y--;
  if (y >= 2) return `${y} y`;
  const months = (ref.getFullYear() - b.getFullYear()) * 12 + md - (ref.getDate() < b.getDate() ? 1 : 0);
  return `${Math.max(0, months)} mo`;
}
